import collapseDirective from 'Site/directive/collapse';
import coverImageMixin from 'Site/js/mixin/cover.image';
import Editable from 'Site/component/Editable.vue';
import Impressions from 'Site/js/util/impressions';
import Geocomplete from 'Location/component/Geocomplete.vue';
import { mapState } from 'vuex';
import MediaPageMixin from 'Wall/js/mixins/media.page';
import PaginationValidation from 'Site/js/mixin/pagination.input.check';
import PromptSignup from 'Site/js/mixin/prompt.signup';
import store from 'Site/js/store';
import User from 'Profile/component/User.vue';
import 'Wall/scss/wall-sidebar.scss';
import Wall from 'Wall/component/Wall.vue';
import WallPost from 'Wall/component/Post.vue';
import Vue from 'vue';
import groupsHeader from '../../component/groupsHeader';
import GroupMembers from '../../component/GroupMembers.vue';

function groups() {
    if (document.getElementById('groups-body')) {
        new Vue({ /* eslint no-new: 0 */
            el: '#groups-body',
            name: 'groupsList',
            store,
            mixins: [PaginationValidation, PromptSignup]
        });
    }

    new Impressions('.profile-avatar', 'Group');
}

export default {
    groups,
    'groups-paginator': groups,
    'groups-search': groups,
    'groups-search-paginator': groups,
    'groups-view': () => {
        groupsHeader();

        new Vue({ /* eslint no-new: 0 */
            el: '#group-body',
            name: 'groupBody',
            store,
            computed: mapState({
                id: state => state.config.data.id,
                groupAjaxParams: state => ({ url: 'group', id: state.config.data.id }),
                interestOptions: state => state.config.data.interests,
                sexualOrientationOptions: state => state.config.data.sexualOrientations,
                t: state => state.t
            }),
            components: {
                Editable,
                GroupMembers,
                Wall
            },
            directives: {
                collapse: collapseDirective
            }
        });
    },
    'groups-view-view-post': () => {
        groupsHeader();

        new Vue({ /* eslint no-new: 0 */
            el: '#group-body',
            name: 'groupBody',
            store,
            computed: mapState({
                t: state => state.t
            }),
            components: {
                WallPost
            }
        });
    },
    'groups-view-view-members': () => {
        groupsHeader();

        new Vue({ /* eslint no-new: 0 */
            el: '#group-body',
            name: 'groupBody',
            store,
            computed: mapState({
                members: state => state.config.data.members,
                t: state => state.t
            }),
            components: {
                GroupMembers,
                User
            },
            methods: {
                memberChange(params) {
                    if (params.action === 'unban' || params.action === 'approve') {
                        this.$store.state.confing.data.members.push(params.member);
                    }
                }
            }
        });
    },
    'groups-view-view-photos': () => {
        groupsHeader();

        new Vue({ /* eslint no-new: 0 */
            el: '#group-body',
            name: 'groupBody',
            store,
            data: {
                type: 'group'
            },
            mixins: [MediaPageMixin]
        });

        new Impressions('.impress-image', 'Group');
    },
    'groups-create': () => {
        new Vue({ /* eslint no-new: 0 */
            el: '#createAndSearch',
            name: 'groupCreate',
            store,
            components: {
                Geocomplete
            },
            computed: mapState({
                t: state => state.t
            }),
            data() {
                return {
                    coverImage: this.$store.state.config.data.coverUrl.replace('REPLACE', 'bubbles/small.jpg'),
                    coverImageName: 'bubbles',
                    coverImageMedia: null,
                    latitude: '',
                    longitude: ''
                };
            },
            methods: {
                changeCoverImage(coverImage) {
                    this.showCoverImageModal = false;
                    this.coverImage = coverImage.url;
                    if (!coverImage.site) {
                        this.coverImageName = null;
                        this.coverImageMedia = coverImage;
                    } else {
                        this.coverImageName = coverImage.name;
                        this.coverImageMedia = null;
                    }
                },
                geocomplete({ result }) {
                    this.latitude = result.geometry.location.lat();
                    this.longitude = result.geometry.location.lng();
                },
            },
            mixins: [coverImageMixin]
        });
    }
};
